import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import Navbar from '../../components/ALLJsx/Navbar';
import Footer from '../../components/ALLJsx/Footer';
import '../AllCss/NotFound.css';

function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLocale();
  
  // Check if user came from a car details page (URL contains /cars/)
  const cameFromCarDetails = location.state?.from?.includes('/cars/') || 
                             document.referrer.includes('/cars/');
  
  // Get the previous path from state or referrer
  const previousPath = location.state?.from || 
                       (document.referrer ? new URL(document.referrer).pathname : null);
  
  // Determine the message and button text based on where they came from
  const getMessage = () => {
    if (cameFromCarDetails) {
      return {
        title: t('notFound.carNotFound'),
        message: t('notFound.carNotFoundMessage'),
        buttonText: t('notFound.backToInventory'),
        buttonPath: '/inventory'
      };
    }
    return {
      title: t('notFound.pageNotFound'),
      message: t('notFound.pageNotFoundMessage'),
      buttonText: t('notFound.goHome'),
      buttonPath: '/'
    };
  };
  
  const { title, message, buttonText, buttonPath } = getMessage();
  
  const handleGoBack = () => {
    // If there's a previous path in history, go back
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Otherwise, navigate to the determined path
      navigate(buttonPath);
    }
  };

  return (
    <>
      <Navbar />
    <section className="NotFound container">
        <h6>404</h6>
        <h2>{title}</h2>
        <p>{message}</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={handleGoBack} className="btn">
            {previousPath && window.history.length > 1 ? t('notFound.goBackToCar') : buttonText}
          </button>
          <Link to={buttonPath} className="btn" style={{ textDecoration: 'none' }}>
            {buttonText}
          </Link>
        </div>
    </section>
      <Footer />
    </>
  );
}

export default NotFound;


